<template>
    <span class="store-view" v-if="stores.length">
        Где можно посмотреть?
        <div class="stores-list">
            <div class="store" v-for="(store, i) of stores" :key="i">
                <div v-for="(value, key) in getAvailableStoreFields(store)" :key="key" :class="key">
                    <span class="label" v-if="fields[key]">{{fields[key]}}:</span>{{value}}
                </div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    props: ['stores'],
    data: () => ({
        fields: {
            name: null,
            address: null,
            workTime: 'Время работы',
            metro: 'Метро',
        },
    }),
    methods: {
        getAvailableStoreFields(store) {
            const fields = {};
            Object.keys(this.fields).forEach((key) => {
                if (store[key]) {
                    fields[key] = store[key];
                }
            })
            return fields;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/colors.scss';

.store-view {
    margin-left: 100px;
    color: #4d4d4d;
    text-decoration: underline dashed;
    position: relative;

    &:hover .stores-list {
        display: block;
    }
}

.stores-list {
    position: absolute;
    width: 400px;
    right: 0;
    top: 0;
    padding: 15px;
    z-index: 4;
    background: white;
    border: 2px solid #ccc;
    border-radius: 5px;
    display: none;

    .store:not(:last-child) {
        margin-bottom: 15px;
    }

    .store>div:not(:last-child) {
        margin-bottom: 10px;
    }

    .name, .label {
        font-weight: 500;
    }

    .name::before {
        display: inline-block;
        content: ' ';
        width: 8px;
        height: 8px;
        margin-right: 8px;
        margin-bottom: 2px;
        background-color: $color-text-green;
        border-radius: 50%;
    }
}
</style>